import { render, staticRenderFns } from "./lp-collections-4.vue?vue&type=template&id=5b37e226&scoped=true"
import script from "./lp-collections-4.vue?vue&type=script&lang=js"
export * from "./lp-collections-4.vue?vue&type=script&lang=js"
import style0 from "./lp-collections-4.vue?vue&type=style&index=0&id=5b37e226&prod&scoped=true&lang=css"
import style1 from "./lp-collections-4.vue?vue&type=style&index=1&id=5b37e226&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b37e226",
  null
  
)

export default component.exports